import {
  GET_ADMIN_LEAD_PRICES,
  GET_ADMIN_LEAD_PRICES_SUCCESS,
  GET_ADMIN_LEAD_PRICES_ERROR,
  UPDATE_ADMIN_LEAD_PRICE,
  UPDATE_ADMIN_LEAD_PRICE_SUCCESS,
  UPDATE_ADMIN_LEAD_PRICE_ERROR
} from "./actionTypes"

const INIT_STATE = {
  admin_lead_prices: [],
  error: null,
  loading: false,
}
const AdminLeadPrices = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_ADMIN_LEAD_PRICES:
      return {
        ...state,
        error: null,
        loading: true,
      }

    case GET_ADMIN_LEAD_PRICES_SUCCESS:
      return {
        ...state,
        error: null,
        admin_lead_prices: action?.payload || [],
        loading: false,
      }

    case GET_ADMIN_LEAD_PRICES_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case UPDATE_ADMIN_LEAD_PRICE:
      return {
        ...state,
        error: null,
        loading: true,
      }

    case UPDATE_ADMIN_LEAD_PRICE_SUCCESS:
      return {
        ...state,
        error: null,
        admin_lead_prices: state.admin_lead_prices.map((item) => (item.id === action.payload.id) ?  ({...item, ...action.payload}) : item),
        loading: false,
      }

    case UPDATE_ADMIN_LEAD_PRICE_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    default:
      return state
  }
}

export default AdminLeadPrices;
